export class GridsState {
  data: { [widgetId: string]: any[] } = {};
}
